import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsISO8601, IsNumber, IsUUID } from 'class-validator';
import { RepairPaymentInterface } from '../interfaces/repair-payment.interface';
import { RepairBumperPaymentTypeEnum } from '../../repair-formula/enums/repair-bumper-payment-type.enum';
import { RepairPaymentTypeEnum } from '../../repair-formula/enums/repair-payment-type.enum';
import { RepairResourceTypeEnum } from '../../repair-formula/enums/repair-resource-type.enum';
import { ContractorDto } from '../../contractor/dto/contractor.dto';
import { RepairDto } from '../../repair/dto/repair.dto';
import { JobRepairDto } from '../../job-repair/dto/job-repair.dto';
import { RepairFormulaDto } from '../../repair-formula/dto/repair-formula.dto';
import { JobPhaseBumpCommonDto } from '../../job-phase-bump/dtos/job-phase-bump-common.dto';

@Exclude()
export class RepairPaymentDto
  extends JobPhaseBumpCommonDto
  implements RepairPaymentInterface
{
  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Job Repair ID',
  })
  @IsUUID()
  @Expose()
  jobRepairId!: string;

  @ApiPropertyOptional({
    type: () => JobRepairDto,
    title: 'Job Repair',
    description: 'Job Repair',
  })
  @Expose()
  jobRepair?: JobRepairDto;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Repair ID',
  })
  @IsUUID()
  @Expose()
  repairId!: string;

  @ApiPropertyOptional({
    type: () => RepairDto,
    title: 'Repair',
    description: 'The Repair associeted',
  })
  @Expose()
  repair?: RepairDto;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Repair Formula ID',
  })
  @IsUUID()
  @Expose()
  repairFormulaId!: string;

  @ApiPropertyOptional({
    type: () => RepairFormulaDto,
    title: 'Repair Formula',
    description: 'The Repair Formula associeted',
  })
  @Expose()
  repairFormula?: RepairFormulaDto;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Contractor ID',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiProperty({
    type: () => ContractorDto,
    title: 'Associated Contractor',
    description: 'The contractor associated',
  })
  @Expose()
  contractor?: ContractorDto;

  @ApiProperty({
    title: 'RepairResourceTyp',
    nullable: true,
  })
  @Expose()
  repairResourceType!: RepairResourceTypeEnum;

  @ApiProperty({
    title: 'RepairPaymentType',
    nullable: true,
  })
  @Expose()
  repairPaymentType!: RepairPaymentTypeEnum;

  @ApiProperty({
    title: 'RepairBumperPayment',
    nullable: true,
  })
  @Expose()
  repairBumperPaymentType!: RepairBumperPaymentTypeEnum;

  @ApiProperty({
    title: 'fixedAmount',
    description: 'FixedAmount of this payment',
  })
  @IsNumber()
  @Expose()
  fixedAmount!: number | null;

  @ApiProperty({
    title: 'extraHours',
    description: 'ExtraHours of this payment',
  })
  @IsNumber()
  @Expose()
  extraHours!: number | null;

  @ApiProperty({
    title: 'calculateCost',
    description: 'CalculateCost of this payment',
  })
  @IsNumber()
  @Expose()
  calculateCost!: number | null;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'date-time',
    title: 'Repair Payment Date',
    description: 'Repair Date of this payment',
  })
  @IsISO8601({ strict: true })
  @Expose()
  repairPaymentDate!: Date | null;

  @ApiProperty({
    title: 'stampRegionRate',
    description: 'stampRegionRate',
  })
  @IsNumber()
  @Expose()
  stampRegionRate!: number | null;

  @ApiProperty({
    title: 'stampBumperPaymentRate',
    description: 'stampBumperPaymentRate',
  })
  @IsNumber()
  @Expose()
  stampBumperPaymentRate!: number | null;
}
